import { Colors } from '@/constants/theme';
import { useColorScheme } from '@/hooks/use-color-scheme';

type ThemeColorName = keyof typeof Colors.light & keyof typeof Colors.dark;
type ThemeColorProps = { light?: string; dark?: string };

function getThemeColor(
  theme: 'light' | 'dark',
  props: ThemeColorProps,
  colorName: ThemeColorName,
): string {
  const colorFromProps = props[theme];
  if (colorFromProps) return colorFromProps;
  return Colors[theme][colorName];
}

export function useThemeColor(
  colorName: ThemeColorName,
): string;
export function useThemeColor(
  props: ThemeColorProps,
  colorName: ThemeColorName,
): string;
export function useThemeColor(
  propsOrColorName: ThemeColorProps | ThemeColorName,
  colorName?: ThemeColorName,
): string {
  const theme = (useColorScheme() ?? 'light') as 'light' | 'dark';
  const isColorNameOnly =
    typeof propsOrColorName === 'string';
  const props: ThemeColorProps = isColorNameOnly ? {} : (propsOrColorName as ThemeColorProps);
  const name: ThemeColorName = (isColorNameOnly ? propsOrColorName : colorName) as ThemeColorName;
  return getThemeColor(theme, props, name);
}
